import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { colors, fonts, spacing } from '../../constants';

/**
 * DialogFooter Component
 * Reusable dialog footer with cancel and submit buttons
 */
const DialogFooter = ({ onCancel, onSubmit, submitLoading, submitLabel = 'Save' }) => {
  return (
    <Box
      sx={{
        borderTop: `1px solid ${colors.borderLight}`,
        px: spacing.lg,
        py: '16px',
        gap: '12px',
        backgroundColor: '#FAFAFA',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Button
        onClick={onCancel}
        variant="outlined"
        sx={{
          color: '#6B7280',
          borderColor: '#E5E7EB',
          textTransform: 'none',
          fontWeight: fonts.weightMedium,
          fontSize: '12px',
          px: '22px',
          py: '5px',
          borderRadius: '8px',
          '&:hover': {
            borderColor: '#D1D5DB',
            backgroundColor: '#F9FAFB',
          },
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        disabled={submitLoading}
        sx={{
          background: colors.primaryGradient,
          color: colors.textWhite,
          textTransform: 'none',
          fontWeight: fonts.weightSemiBold,
          fontSize: '12px',
          px: '22px',
          py: '5px',
          borderRadius: '8px',
          boxShadow: `0 12px 24px ${colors.primaryShadow}`,
          '&:hover': {
            background: colors.primaryGradientHover,
            boxShadow: `0 16px 32px ${colors.primaryShadow}`,
          },
          '&:disabled': {
            backgroundColor: colors.borderDefault,
            color: colors.textSecondary,
          },
        }}
      >
        {submitLoading ? (
          <>
            <CircularProgress size={16} sx={{ color: colors.textWhite, mr: 1 }} />
            Saving...
          </>
        ) : (
          submitLabel
        )}
      </Button>
    </Box>
  );
};

export default DialogFooter;
